import React from "react";
import { Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import { IconAlertTriangle, IconNotes, IconShirt } from "@tabler/icons-react";

import {
  ALTERATION_MAX_LENGTH,
  isHalfInchIncrement,
} from "./alterationFormConfig";

/**
 * One panel (Front or Back) of the alteration form: the seven measurement
 * inputs grouped the way the printed form groups them, plus the panel's
 * "Additional Comments" box.
 *
 * All inputs are optional — the half-inch note is a hint, never a blocker.
 */
function AlterationPanelSection({ panel, values, onChange, disabled }) {
  const commentValue = values[panel.commentsKey] || "";

  return (
    <Card className="mb-3 card_suggestion">
      <Card.Header className="card_header">
        <IconShirt stroke={1} /> {panel.title}
      </Card.Header>
      <Card.Body>
        {panel.groups.map((group) => (
          <Row key={`${panel.key}-${group.group}`} className="align-items-start">
            <Col md={3}>
              <div className="fw-semibold pt-2 mb-2">{group.group}</div>
            </Col>
            <Col md={9}>
              <Row>
                {group.items.map((item) => {
                  const value = values[item.key] || "";
                  const showIncrementHint =
                    value.trim() !== "" && !isHalfInchIncrement(value);

                  return (
                    <Col md={6} key={item.key}>
                      <Form.Group className="mb-3">
                        <Form.Label>{item.label}</Form.Label>
                        <InputGroup>
                          <Form.Control
                            type="text"
                            inputMode="decimal"
                            value={value}
                            disabled={disabled}
                            maxLength={ALTERATION_MAX_LENGTH.measurement}
                            placeholder="0"
                            onChange={(event) =>
                              onChange(item.key, event.target.value)
                            }
                          />
                          <InputGroup.Text>inches</InputGroup.Text>
                        </InputGroup>
                        {showIncrementHint && (
                          <span className="text-warning small d-inline-flex align-items-center gap-1">
                            <IconAlertTriangle stroke={1} size={14} />
                            Form allows 1/2 inch increments only
                          </span>
                        )}
                      </Form.Group>
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Row>
        ))}

        <Row>
          <Col md={12}>
            <Form.Group className="mb-0">
              <Form.Label className="d-inline-flex align-items-center gap-1">
                <IconNotes stroke={1} size={18} /> Additional Comments
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={commentValue}
                disabled={disabled}
                maxLength={ALTERATION_MAX_LENGTH.comment}
                placeholder={`Describe any ${panel.title.toLowerCase()} changes not covered above`}
                onChange={(event) =>
                  onChange(panel.commentsKey, event.target.value)
                }
              />
              <div className="text-muted small text-end">
                {commentValue.length}/{ALTERATION_MAX_LENGTH.comment}
              </div>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default AlterationPanelSection;
